import React from 'react';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  target?: string;
  rel?: string;
};
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  href,
  onClick,
  disabled = false,
  loading = false,
  target,
  rel
}: ButtonProps) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 ease-out tracking-wide';
  const variantClasses = {
    primary: 'bg-primary hover:bg-secondary text-white shadow-md hover:shadow-lg',
    secondary: 'bg-white hover:bg-gray-50 text-dark border border-gray-200 shadow-sm hover:shadow-md',
    success: 'bg-[#25D366] hover:bg-[#1ebe5d] text-white shadow-md hover:shadow-lg',
    outline: 'bg-transparent border-2 border-white/40 text-white hover:bg-white/10 hover:border-white/60 backdrop-blur-sm'
  };
  const sizeClasses = {
    sm: 'text-sm py-2.5 px-4',
    md: 'text-base py-3 px-5',
    lg: 'text-lg py-3.5 px-8'
  };
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`;
  if (href && !disabled) {
    return <a href={href} className={classes} target={target} rel={rel} onClick={onClick as any} data-id="element-431" data-mp="12mjxjs0qcp0i">
        {loading ? <span className="mr-2 inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-432" data-mp="1cd54c2qk4zui"></span> : null}
        {children}
      </a>;
  }
  return <button type={type} className={classes} onClick={onClick} disabled={disabled || loading} data-id="element-433" data-mp="1le2zrwmxjz1h">
      {loading ? <span className="mr-2 inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-434" data-mp="1hdsruefkuyjz"></span> : null}
      {children}
    </button>;
};
export default Button;